// simple but fast string comparison;
// if we ever need to support japanese or umlauts, we can use localeCompare() instead

// returns 0 when both strings are the same
module.exports = (s1, s2) => (s1 > s2) - (s1 < s2)
